export const data = [
  {
    client_name: "ggnfc6",
    value: 2678519,
    otif: 94.5355191256831,
    quantity: 1488
  },
  {
    client_name: "ggnfc8",
    value: 6304942,
    otif: 94.6643213133978,
    quantity: 3447
  },
  {
    client_name: "ggnfc5",
    value: 1784240,
    otif: 94.672131147541,
    quantity: 990
  },
  {
    client_name: "ggnfc7",
    value: 2694387,
    otif: 94.7332421340629,
    quantity: 1478
  }
];
export const displayedColumns2 = ["customer", "otif", "value", "quantity"];
